import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const query = gql`
query ActivityNotifications {
  activityNotifications {
    id
    name
    event
    text
    active
    channels {
      id
      name
    }
    requestTypePriorities {
      id
      requestType{
        id
        name
      }
      channel {
        id
        name
      }
    }
  }
}`;

function getActivityNotifications() {
  return apollo.client.query({
    query,
    fetchPolicy: 'network-only',
  }).then((res) => res.data.activityNotifications);
}

export default getActivityNotifications;
